<template>
  <div class="page-view campaign">
    <router-link class="back-to" to="/">
      <v-icon name="fa-chevron-left" />Home
    </router-link>
    <div class="container" v-if="campData">
      <div class="item">
        <h1 class="page-title" v-if="campData.description">—{{campData.description}}</h1>
        <h3 class="subtitle" v-if="campData.bp_name">{{campData.bp_name}}</h3>
        <!-- <h3 class="subtitle">📅&nbsp;{{timeFormatter(campData.start)}}—{{timeFormatter(campData.end)}}</h3> -->
      </div>
    </div>

    <PVStatus v-if="campData" :campData="campData" :extraData="extraData" />

    <div class="container" v-if="campData">
      <div class="flex-wrapper bg-primary-lgray mt-8 pb-4">
        <div class="item large">
          <div v-if="loading">
            <v-icon name="fa-spinner" class="animate-spin text-gray-400 w-20" />
          </div>
          <h4 class="end" v-if="!isActive && !loading">
            La campagna non è attiva.<br>
            <small>Non è possibile effettuare ordini in questo momento.</small>
          </h4>
          <div class="new-order" v-if="isActive && !loading">
            <!-- v-else -->
            <!-- STEP 1 -->
            <section class="step step-1" v-show="step === 1">
              <header>
                <h4>
                  Effettua un nuovo ordine
                  <small>
                    #{{(!pastOrders || !pastOrders.length) ? 1 : pastOrders[0].id + 1}}
                    <span v-if="pv" class="text-xs tracking-wide">— P.V. <b class="text-sm">{{pv}}</b>
                      {{getPvName(pv)}}</span>
                  </small>
                </h4>
                <div class="button-group">
                  <button class="ahead" @click="goTo(2)" :class="{disabled : !pv}">
                    Avanti
                    <v-icon name="bi-arrow-right-short" />
                  </button>
                </div>
              </header>
              <div class="table-wrapper overflowed">
                <table>
                  <thead>
                    <tr>
                      <th>Seleziona un Punto Vendita</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <AdvancedSearch :list="activepvs" :filter="'code'" :info="'name'" :placeholder="'Punti Vendita'"
                          :overrider="pvOverrider" @changeValue="selectPV" />
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                  </tfoot>
                </table>
              </div>
            </section>
            <!-- STEP 2 -->
            <section class="step step-2" v-show="step === 2">
              <header>
                <h4>
                  Effettua un nuovo ordine
                  <small>
                    #{{(!pastOrders || !pastOrders.length) ? 1 : pastOrders[0].id + 1}}
                    <span v-if="pv" class="text-xs tracking-wide">— P.V. <b class="text-sm">{{pv}}</b>
                      {{getPvName(pv)}}</span>
                  </small>
                </h4>
                <div class="button-group">
                  <button class="behind" @click="goTo(1)">
                    <v-icon name="bi-arrow-left-short" />Indietro
                  </button>
                  <button class="ahead" @click="goTo(3)">
                    Avanti
                    <v-icon name="bi-arrow-right-short" />
                  </button>
                </div>
              </header>
              <div class="table-wrapper overflowed order-table" v-if="!reloadTable">
                <table>
                  <tbody>
                    <div class="row" v-for="(item, index) in items" :key="index">
                      <div class="column">
                        <v-icon v-if="index > 0 && index + 1 === items.length" title="Rimuovi riga"
                          @click="removeEl(index)" class="remove" name="pr-minus-circle" />
                      </div>
                      <div class="column">
                        <!-- search by CODE -->
                        <label>Articolo*</label>
                        <AdvancedSearch :list="extraData.use_only_default_substitute_code ? alternates : prodAlt"
                          :filter="'substitute'" :index="index" :placeholder="'ID articolo'"
                          :overrider="overrider[index].name" @changeValue="addItemByCode" />
                      </div>
                      <div class="column">
                        <label>Descrizione</label>
                        <!-- search by NAME -->
                        <AdvancedSearch :list="extraData.use_only_default_substitute_code ? products : prodAlt"
                          :filter="'item_description'" :index="index" :placeholder="'Nome articolo'"
                          :overrider="overrider[index].code" @changeValue="addItemByName" />
                      </div>
                      <div class="column">
                        <label>Quantità*</label>
                        <input type="number" min="1" required v-model="items[index].qta" @change="validateQta(index)">
                      </div>
                      <div class="column" v-if="shownFields.includes('loyalty_card')">
                        <label>Carta Fedeltà<span v-if="requiredFields.includes('loyalty_card')">*</span></label>
                        <input
                          placeholder="N° Carta"
                          type="text"
                          maxlength="13"
                          @change="eanResult(items[index].card)"
                          v-model="items[index].card"
                          :required="requiredFields.includes('loyalty_card') ? true : false"
                          :disabled="lockedFields.includes('loyalty_card')"
                        >
                      </div>
                      <div class="column">
                        <!-- <input
                          type="checkbox"
                          :id="'shipping-' + index"
                          :name="'shipping-' + index"
                          v-model="items[index].spediz.bool"
                          @change="refreshInput(items[index].spediz.bool, index)"
                        >
                        <label :for="'shipping-' + index">E-mail</label> -->
                        <label v-if="checkGroup(items[index].article) || lineHomeDelivery(index)">Email *</label>
                        <input
                          v-if="checkGroup(items[index].article) || lineHomeDelivery(index)"
                          type="mail"
                          @blur="validateEmail(index)"
                          v-model="items[index].spediz.email"
                          placeholder="Indirizzo"
                          :required="checkGroup(items[index].article) || lineHomeDelivery(index) ? true : false"
                          :disabled="lockedFields.includes('email')"
                        />
                      </div>
                      <div class="column" v-if="shownFields.includes('customer_firstname')">
                        <label>Nome<span v-if="requiredFields.includes('customer_firstname')">*</span></label>
                        <input placeholder="Nome"
                          type="text"
                          v-model="items[index].firstname"
                          :required="requiredFields.includes('customer_firstname') ? true : false"
                          :disabled="lockedFields.includes('customer_firstname')"
                        >
                      </div>
                      <div class="column" v-if="shownFields.includes('customer_lastname')">
                        <label>Cognome<span v-if="requiredFields.includes('customer_lastname')">*</span></label>
                        <input
                          placeholder="Cognome"
                          type="text"
                          v-model="items[index].lastname"
                          :required="requiredFields.includes('customer_lastname') ? true : false"
                          :disabled="lockedFields.includes('customer_lastname')"
                        >
                      </div>
                      <div class="column" v-if="shownFields.includes('customer_business_name')">
                        <label>Ragione sociale<span
                            v-if="requiredFields.includes('customer_business_name')">*</span></label>
                        <input
                          type="text"
                          v-model="items[index].customer.business"
                          maxlength="50"
                          :required="requiredFields.includes('customer_business_name') ? true : false"
                          :disabled="lockedFields.includes('customer_business_name')"
                        >
                      </div>
                      <div class="column" v-if="shownFields.includes('customer_client_code')">
                        <label>Codice cliente<span
                            v-if="requiredFields.includes('customer_client_code')">*</span></label>
                        <input
                          type="text"
                          v-model="items[index].customer.client"
                          :required="requiredFields.includes('customer_client_code') ? true : false"
                          :disabled="lockedFields.includes('customer_client_code')"
                        >
                      </div>
                      <div class="column" v-if="shownFields.includes('customer_phone_number')">
                        <label>N° Telefono<span v-if="requiredFields.includes('customer_phone_number') || lineInPrenotazione(index)">*</span></label>
                        <input
                          type="tel"
                          v-model="items[index].customer.phone"
                          :required="requiredFields.includes('customer_phone_number') || lineInPrenotazione(index) ? true : false"
                          :disabled="lockedFields.includes('customer_phone_number')"
                        >
                      </div>
                      <div class="column">
                        <v-icon v-if="index + 1 === items.length && items[index].article" title="Aggiungi riga"
                          @click="addEl(index + 1)" class="add" name="pr-plus-circle" />
                      </div>
                    </div>
                  </tbody>
                  <tfoot>
                  </tfoot>
                </table>
              </div>
            </section>
            <!-- STEP 3 -->
            <section class="step step-3" v-show="step === 3">
              <header>
                <h4>
                  Effettua un nuovo ordine
                  <small>
                    #{{(!pastOrders || !pastOrders.length) ? 1 : pastOrders[0].id + 1}}
                    <span v-if="pv" class="text-xs tracking-wide">— P.V. <b class="text-sm">{{pv}}</b>
                      {{getPvName(pv)}}</span>
                  </small>
                </h4>
                <div class="button-group">
                  <button class="behind" @click="goTo(2)">
                    <v-icon name="bi-arrow-left-short" />Indietro
                  </button>
                </div>
              </header>
              <div class="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>Articolo</th>
                      <th class="px-4">Desc</th>
                      <th>Qta</th>
                      <th v-if="shownFields.includes('loyalty_card')">Carta</th>
                      <th>Spedizione</th>
                      <th
                        v-if="shownFields.includes('customer_firstname') || shownFields.includes('customer_lastname')">
                        Nome & Cognome
                      </th>
                      <th v-if="shownFields.includes('customer_business_name')">
                        Ragione sociale
                      </th>
                      <th v-if="shownFields.includes('customer_client_code')">
                        Codice cliente
                      </th>
                      <th v-if="shownFields.includes('customer_phone_number')">
                        N° Tel.
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, index) in items" :key="index">
                      <tr>
                        <td class="resume"><b class="text-primary-blue"
                            v-if="item.article">{{item.article.substitute}}</b></td>
                        <td class="resume">{{getDescription(items[index].article)}}</td>
                        <td class="resume"><b class="text-primary-lblue">{{item.qta}}</b></td>
                        <td v-if="shownFields.includes('loyalty_card')" class="resume">{{item.card}}
                        </td>
                        <td class="resume truncate" :title="getMail(item)">{{ getMail(item) }}</td>
                        <td v-if="shownFields.includes('customer_firstname') || shownFields.includes('customer_lastname')"
                          class="resume">
                          {{item.firstname + ' ' + item.lastname}}
                        </td>
                        <td v-if="shownFields.includes('customer_business_name')" class="resume">
                          {{item.customer.business}}
                        </td>
                        <td v-if="shownFields.includes('customer_client_code')" class="resume">
                          {{item.customer.client}}
                        </td>
                        <td v-if="shownFields.includes('customer_phone_number')" class="resume">
                          {{item.customer.phone}}
                        </td>
                      </tr>
                      <tr v-if="lineHomeDelivery(index)" class="ship-to-row">
                        <td colspan="99" class="pt-2 pb-4">
                          <div class="text-primary-blue font-semibold text-sm mb-1">
                            Indirizzo di spedizione — Riga #{{ index + 1 }}
                          </div>
                          <ShipToFields v-model="items[index].shipTo" />
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <tfoot>
                  </tfoot>
                </table>
              </div>
              <button type="submit" class="confirm-order-btn" @click="tryOrder">
                Conferma l'ordine
              </button>
            </section>
            <section class="step step-4" v-show="step === 4">
              <header>
                <h4 v-if="!checkSuccess(orderSuccess)">
                  ⚠Errore—i seguenti ordini non sono stati elaborati correttamente:
                  <small class="mt-4">
                    <span v-for="(success, index) in orderSuccess" :key="index">
                      <span v-if="success.failed">—{{success.item}}</span><br />
                    </span>
                  </small>
                  <span class="block mt-8">
                    <a href="#" @click.prevent="refresh" class="text-primary-orange hover:underline">Riprovare</a>
                    oppure contattare l'assistenza.
                  </span>
                </h4>
                <h4 v-else>
                  Ordine inviato correttamente.
                  <small class="ml-4">
                    <span>
                      Attendi, oppure <a href="#" @click.prevent="refresh"
                        class="text-primary-orange hover:underline">ricarica</a> la pagina.
                    </span>
                  </small>
                </h4>
              </header>
            </section>
            <small class="disclaimer" v-if="step === 2">* Campi obbligatori</small>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-else>
      LOADING ...
    </div>

    <!-- PAST ORDERS -->
    <div class="divider">
      <div class="container mx-auto px-4">
        <h3>
          Ordini <b>Precedenti</b>
        </h3>
      </div>
    </div>
    <div class="past-filters" v-if="campData">
      <div class="container mx-auto px-4">
        <h6>—Filtri</h6>
        <ul>
          <li class="field">
            <!-- search by ID -->
            <AdvancedSearch v-if="!searchPast.resetPastID && !searchReset"
              :list="extraData.use_only_default_substitute_code ? alternates : prodAlt" :filter="'substitute'"
              :info="'item_description'" :placeholder="'Articolo'" @changeValue="changePastItem" />
          </li>
          <li class="field">
            <!-- search by PV -->
            <AdvancedSearch v-if="!searchPast.resetPastPv && !searchReset" :list="pvs" :filter="'code'" :info="'name'"
              :placeholder="'Punto Vendita'" @changeValue="changePastPv" />
          </li>
          <li class="field">
            <input type="text" v-if="shownFields.includes('loyalty_card')" name="loyalty" id="loyalty" placeholder="Carta Fedeltà" v-model="searchPast.loyalty" />
          </li>
          <li class="field">
            <input type="text" name="search-name" id="search-name" placeholder="Nome / Cognome utente" v-model="searchPast.nameSurname" />
          </li>
          <li class="field">
            <input type="date" name="from" id="date-from" v-model="date.from" />
          </li>
          <li class="field">
            <input type="date" name="to" id="date-to" :min="date.from" v-model="date.to" />
          </li>
        </ul>
        <ul>
          <li><button class="btn reset" @click="filterPastReset">Reset</button></li>
          <li><button class="btn go" @click="filterPast(true)">Cerca</button></li>
        </ul>
      </div>
    </div>
    <section class="past-orders" v-if="!loading"><!-- && !loading2 -->
      <div class="container mx-auto px-4">
        <ul v-if="pastOrders && pastOrders.length">
          <li v-for="order in pastOrders" :key="order.id">
            <OrderTeaser :order="order" :desc="getDescription(order, true)" :pvs="pvs" />
          </li>
        </ul>
        <h5 class="error" v-else>Non risultano ordini <b>precedenti</b> al momento.</h5>

        <div class="export-orders" v-if="pastOrders && pastOrders.length">
          <hr />
          <h6>✉ Vuoi esportare gli ordini? (il file verrà inviato all'indirizzo mail dell'utente corrente)</h6>
          <button class="btn btn-orange" @click.prevent="exportOrders">Esporta</button>
        </div>
      </div>
    </section>
    <section class="past-orders text-center" v-if="loading"><!-- || loading2 -->
      <v-icon name="fa-spinner" class="animate-spin text-gray-400 w-20" />
    </section>
    <a class="logout" to="/login" href="#" @click.prevent="logout">
      ‹‹ Logout <b v-if="userData">{{userData.email}}</b>
    </a>
  </div>
</template>

<script>
// import campaigns from '@/json/mock/campaigns.json'
// import orders from '@/json/mock/orders.json'
import { checkEan } from '@/utils/ean13.js'
import AdvancedSearch from '@/components/AdvancedSearch.vue'
import OrderTeaser from '@/components/OrderTeaser.vue'
import PVStatus from '@/components/PVStatus.vue'
import ShipToFields from '@/components/ShipToFields.vue'
import { SAP_ITALIAN_PROVINCES } from '@/utils/province-sap.js'
import moment from 'moment'
moment.locale('it')

export default {
  components: {
    AdvancedSearch,
    OrderTeaser,
    PVStatus,
    ShipToFields
  },
  data () {
    return {
      loading: true,
      loading2: false,
      isActive: false,
      campData: null,
      reloadTable: false,
      step: 1,
      pv: null,
      items: [],
      pastOrders: [],
      orderSuccess: [],
      overrider: [],
      products: null,
      alternates: null,
      prodAlt: [],
      pvs: null,
      activepvs: null,
      pvOverrider: null,
      eanCheck: this.shownFields && this.shownFields.includes('loyalty_card') ? false : null,
      prodCodes: null,
      historyCounter: 0,
      historyLimit: 18,
      counter: 0,
      stopFire: false,
      searchReset: false,
      date: {
        from: null,
        to: null
      },
      searchPast: {
        article: null,
        pv: null,
        nameSurname: null,
        resetPastID: false,
        resetPastPv: false
      }
    }
  },
  computed: {
    userData () {
      return this.$store.state.userData
    },
    extraData () {
      return this.$store.state.userData ? JSON.parse(this.$store.state.userData.extra_data) : false
    },
    shownFields () {
      if (this.extraData && this.extraData.shown_fields === undefined) return []
      else return this.extraData.shown_fields
    },
    lockedFields () {
      if (this.extraData && this.extraData.locked_fields === undefined) return []
      else return this.extraData.locked_fields
    },
    requiredFields () {
      if (this.extraData && (this.extraData.required_fields === undefined || this.extraData.required_fields === null)) return []
      else return this.extraData.required_fields
    }
  },
  async mounted () {
    console.log('---CAMPAIGNS', this.$store.state.campaigns)
    console.log('---extra', this.extraData)
    const camp = this.$store.state.campaigns ? this.$store.state.campaigns.filter((el) => {
      return el.id === parseInt(this.$route.params.id)
    }) : null
    this.campData = camp ? camp[0] : null
    console.log('---CURRENT CAMPAIGN', this.campData)

    if (this.campData) {
      this.checkIsActive()
      await this.$store.dispatch('getSingleAgreement', this.campData.agreement_no)
        .then((rsp) => {
          this.products = rsp.filter((el) => {
            return el.item_group === 100 || el.item_group === 101 || el.item_group === 108 || el.properties5 === true
          })
        })
      const payload2 = {
        agreement_no: this.campData.agreement_no,
        card: this.campData.bp_code
      }
      await this.$store.dispatch('getCampaignAlternates', payload2)
        .then((rsp) => {
          const defaults = this.extraData && this.extraData.use_only_default_substitute_code ? this.extraData.use_only_default_substitute_code : false
          if (this.extraData && defaults) {
            this.alternates = rsp.filter((el) => {
              return el.is_default || el.agreement_no === this.campData.agreement_no
            })

            const crossTable = []
            this.alternates = this.alternates.filter((el) => {
              const code = el.item_code

              this.products.filter((el2) => {
                if (el2.item_no === code) {
                  crossTable.push(code)
                }
              })

              if (crossTable.includes(code)) return el
            })

            // ---IF item_enabled_codes in extra data
            if (this.extraData && this.extraData.item_enabled_codes && this.extraData.item_enabled_codes.length > 0) {
              const tempTable = []
              const enabled = this.extraData.item_enabled_codes

              // ---CHECK IF RSP INCLUDES SOME SUBSTITUTES FROM EXTRADATA
              let tempAlternates = rsp.filter((el3) => {
                return enabled.includes(el3.substitute)
              })

              // ---CROSS WITH PRODUCT TABLE
              tempAlternates = tempAlternates.filter((el4) => {
                const code = el4.item_code

                this.products.filter((el5) => {
                  // console.log(el2.item_no, code)
                  if (el5.item_no === code) {
                    tempTable.push(code)
                  }
                })

                if (tempTable.includes(code)) return el4
              })

              // ---CROSS WITH THE ALREADY FILTERED ALTERNATE CAT NUM
              tempAlternates = tempAlternates.filter((el6) => {
                const sub = el6.substitute
                let found = false

                for (let i = 0; i < this.alternates.length; i++) {
                  if (sub === this.alternates[i].substitute) {
                    found = true
                    break
                  }
                }

                return found === false
              })

              console.log('#THEN, FILTERED BY (ALREADY) FILTERED ALTERNATE', tempAlternates)
              this.alternates = this.alternates.concat(tempAlternates)
            }
          } else {
            this.alternates = rsp
          }
        })

      if (this.extraData.use_only_default_substitute_code) {
        this.alternates.map((el) => {
          this.prodAlt.push(el)
        })
      } else {
        this.products.map((el) => {
          el.description = el.item_description
          el.item_code = el.substitute = el.item_no
          this.prodAlt.push(el)
        })
        this.alternates.map((el) => {
          this.prodAlt.push(el)
        })
      }

      const payload = {
        bp_code: this.campData.bp_code,
        agreement_no: this.campData.agreement_no
      }
      await this.$store.dispatch('getCampaignPVs', payload)
        .then((rsp) => {
          const kind = this.extraData && this.extraData.pos_enabled_kinds ? this.extraData.pos_enabled_kinds : false
          const enabled = this.extraData && this.extraData.pos_enabled_codes ? this.extraData.pos_enabled_codes : false
          let finalList = rsp
          if (this.extraData && this.extraData.pos_enabled_kinds) {
            finalList = finalList.filter((el) => {
              return kind.includes(el.kind)
            })
          }
          if (this.extraData && this.extraData.pos_enabled_codes) {
            finalList = finalList.filter((el) => {
              return enabled.includes(el.code)
            })
          }
          let onlyactive = finalList
          onlyactive = onlyactive.filter((el) => {
            return el.is_active === true
          })
          this.pvs = finalList
          this.activepvs = onlyactive
          // Se c'è un solo PV disponibile, preselezionalo: risparmia un click
          // all'utente e popola anche l'input dell'AdvancedSearch via overrider.
          if (onlyactive.length === 1) {
            this.pv = onlyactive[0].code
            this.pvOverrider = onlyactive[0].code + ' - ' + onlyactive[0].name
          }
        })
      const data = {
        agreement: this.campData.agreement_no,
        skip: 0,
        limit: this.historyLimit
      }
      await this.$store.dispatch('getPastOrders', data)
        .then((rsp) => {
          this.pastOrders = rsp
        })
    }
    this.addEl()
    setTimeout(() => {
      this.loading = false
    }, 2000)

    window.onscroll = async (ev) => {
      const pastScrolled = (window.innerHeight + window.scrollY) >= document.body.offsetHeight
      const checkPostLimit = this.pastOrders.length >= (this.historyCounter * this.historyLimit)
      if (pastScrolled && checkPostLimit && !this.stopFire) {
        this.stopFire = true
        // you're at the bottom of the page
        this.historyCounter += 1
        let skip
        let limit
        let data
        if (!this.searchPast.article && !this.searchPast.pv && !this.searchPast.nameSurname && !this.date.from && !this.date.to) {
          skip = this.historyCounter * this.historyLimit
          limit = this.historyLimit
          data = {
            agreement: this.campData.agreement_no,
            skip,
            limit
          }
        } else {
          skip = this.historyCounter * this.historyLimit
          limit = this.historyLimit
          data = {
            agreement: this.campData.agreement_no,
            skip: skip,
            limit: limit
          }
          if (this.searchPast.nameSurname) {
            data.full_name = this.searchPast.nameSurname
          }
          if (this.date.from) {
            data.from = this.date.from
          }
          if (this.date.to) {
            data.to = this.date.to
          }
          if (this.searchPast.pv) {
            data.pdv_id = this.searchPast.pv
          }
          if (this.searchPast.article) {
            data.item_id = this.searchPast.article
          }
          if (this.searchPast.loyalty) {
            data.loyalty_card = this.searchPast.loyalty
          }
        }

        await this.$store.dispatch('getPastOrders', data)
          .then((rsp) => {
            this.pastOrders = this.pastOrders.concat(rsp)
            this.stopFire = false
          })
      } else {
        this.stopFire = false
      }
    }
  },
  methods: {
    checkEan,
    checkIsActive () {
      const start = moment(this.campData.start_date)
      const end = moment(this.campData.end_date)
      const today = moment()

      if (today.isBetween(start, end)) {
        this.isActive = true
      }
    },
    async exportOrders () {
      const data = {
        email: this.userData.email,
        agreement: this.campData.agreement_no
      }
      await this.$store.dispatch('exportOrders', data)
        .then((rsp) => {
          if (rsp) {
            const msg = 'Export inviato correttamente: controllare all\'indirizzo ' + this.userData.email
            const error = false
            this.emitter.emit('fireAlert', { msg, error })
          } else {
            const msg = 'Errore durante l\'export: riprovare più tardi.'
            const error = true
            this.emitter.emit('fireAlert', { msg, error })
          }
        })
    },
    changePastItem (val) {
      this.searchPast.article = val
    },
    changePastPv (val) {
      this.searchPast.pv = val
    },
    async filterPastReset () {
      this.searchPast = {
        article: null,
        pv: null,
        name: null,
        surname: null,
        resetPastID: true,
        resetPastPv: true
      }
      this.date = {
        from: null,
        to: null
      }
      setTimeout(() => {
        this.searchPast.resetPastID = false
        this.searchPast.resetPastPv = false
        this.historyCounter = 0
      }, 100)

      const data = {
        agreement: this.campData.agreement_no,
        skip: 0,
        limit: this.historyLimit
      }
      await this.$store.dispatch('getPastOrders', data)
        .then((rsp) => {
          this.pastOrders = rsp
        })
    },
    async filterPast (reset, stopLoading) {
      if (!stopLoading) this.loading2 = true
      if (reset) this.historyCounter = 0
      const skip = this.historyCounter * this.historyLimit
      const limit = this.historyLimit
      const data = {
        agreement: this.campData.agreement_no,
        skip: skip,
        limit: limit
      }
      if (this.searchPast.nameSurname) {
        data.full_name = this.searchPast.nameSurname
      }
      if (this.date.from) {
        data.from = this.date.from
      }
      if (this.date.to) {
        data.to = this.date.to
      }
      if (this.searchPast.pv) {
        data.pdv_id = this.searchPast.pv
      }
      if (this.searchPast.article) {
        data.item_id = this.searchPast.article
      }
      if (this.searchPast.loyalty) {
        data.loyalty_card = this.searchPast.loyalty
      }
      await this.$store.dispatch('getPastOrders', data)
        .then((rsp) => {
          console.log('---UNIFIED search', rsp)
          this.pastOrders = rsp
        })
      this.loading2 = false
    },
    getMail (item) {
      if (item.spediz.email) return item.spediz.email
      else return '—'
    },
    validateQta (index) {
      const target = this.items[index].qta
      if (target < 0) {
        this.items[index].qta = 0
      }
    },
    eanResult (val) {
      this.eanCheck = this.checkEan(val)
    },
    getPvName (pvCode) {
      const target = this.pvs.filter((el) => {
        return el.code === pvCode
      })

      if (target && target[0]) return '(' + target[0].name + ')'
      else return null
    },
    async logout () {
      await this.$store.dispatch('logout')
        .then(() => this.$router.push('/login'))
    },
    selectPV (val) {
      this.pv = val
    },
    addItemByCode (obj) {
      this.overrider[obj.index].name = null
      this.items[obj.index].article = obj.val
      const desc = this.getDescription(obj.val)
      this.overrider[obj.index].code = desc
      if (this.checkGroup(this.items[obj.index].article) && this.userData && this.userData.email) this.items[obj.index].spediz.email = this.userData.email
      this.updateSelectedLine(obj.index)
    },
    addItemByName (obj) {
      this.overrider[obj.index].code = null
      const code = this.getCodeByDesc(obj.val)
      this.items[obj.index].article = code
      this.overrider[obj.index].name = code.substitute
      if (this.checkGroup(this.items[obj.index].article) && this.userData && this.userData.email) this.items[obj.index].spediz.email = this.userData.email
      this.updateSelectedLine(obj.index)
    },
    updateSelectedLine (index) {
      const article = this.items[index] && this.items[index].article
      if (!this.items[index]) return
      if (!article || !this.products) {
        this.items[index].selectedLine = null
        return
      }
      const match = this.products.find((p) => {
        return p.item_no === article.item_code || p.item_no === article.item_no
      })
      this.items[index].selectedLine = match || null
    },
    lineInPrenotazione (index) {
      // Per-riga: articolo "in prenotazione" (caso B o C).
      // Sostituisce il computed globale isInPrenotazione che prima causava
      // leak di stato tra righe diverse nel v-for di step 2.
      const l = this.items[index] && this.items[index].selectedLine
      return !!(l && l.u_pr_in_prenotazione === 'N')
    },
    lineHomeDelivery (index) {
      // Per-riga: articolo "consegna a domicilio" (caso C: in prenotazione + WHS CONNE).
      const l = this.items[index] && this.items[index].selectedLine
      return !!(l && l.u_pr_in_prenotazione === 'N' && l.u_pr_whs_code === 'CONNE')
    },
    checkGroup (tgt) {
      const list = this.extraData.use_only_default_substitute_code ? this.products : this.prodAlt
      const target = list.filter((el) => {
        if (tgt && tgt.item_code) return el.item_no === tgt.item_code
      })
      if (target && target[0] && (target[0].item_group === 101 || target[0].item_group === 108 || target[0].properties5 === true)) return true
      else return false
    },
    validateEmail (index) {
      const mail = this.items[index].spediz.email
      // eslint-disable-next-line
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail) === false) {
        const msg = 'Indirizzo mail non valido'
        const error = true
        this.emitter.emit('fireAlert', { msg, error })
        this.items[index].spediz.email = null
        return false
      } else {
        const msg = 'Indirizzo mail valido'
        const error = false
        this.emitter.emit('fireAlert', { msg, error })
        return true
      }
    },
    refresh (timer) {
      // "timer" è o un numero (ms) o, se chiamato da @click.prevent="refresh",
      // è l'evento stesso — in quel caso trattiamolo come 0.
      const delay = typeof timer === 'number' ? timer : 0
      setTimeout(() => {
        this.softRefresh()
      }, delay)
    },
    async softRefresh () {
      // Reset della form per permettere un nuovo ordine, senza ricaricare
      // la pagina. Ricarica la lista degli ordini precedenti via API.
      this.items = []
      this.overrider = []
      this.orderSuccess = []
      this.pv = null
      this.pvOverrider = null
      if (this.activepvs && this.activepvs.length === 1) {
        this.pv = this.activepvs[0].code
        this.pvOverrider = this.activepvs[0].code + ' - ' + this.activepvs[0].name
      }
      this.eanCheck = this.shownFields && this.shownFields.includes('loyalty_card') ? false : null
      this.addEl()
      this.step = 1

      this.historyCounter = 0
      const data = {
        agreement: this.campData.agreement_no,
        skip: 0,
        limit: this.historyLimit
      }
      await this.$store.dispatch('getPastOrders', data)
        .then((rsp) => {
          this.pastOrders = rsp
        })
    },
    checkSuccess (success) {
      let temp = true
      success.map((el) => {
        if (el && el.failed) temp = false
      })
      return temp
    },
    validateShipTo (index) {
      const shipTo = this.items[index].shipTo
      const missing = []
      const labels = {
        ship_to_street: 'Indirizzo',
        ship_to_zip_code: 'CAP',
        ship_to_city: 'Città',
        ship_to_country: 'Paese',
        ship_to_address_name: 'Destinatario'
      }
      Object.entries(labels).forEach(([key, label]) => {
        if (!shipTo[key]) missing.push(label)
      })
      if (shipTo.ship_to_country === 'IT' && !shipTo.ship_to_state) {
        missing.push('Provincia')
      }
      if (shipTo.ship_to_country && !['IT', 'SM'].includes(shipTo.ship_to_country)) {
        missing.push('Paese (ammessi: IT o SM)')
      }
      if (shipTo.ship_to_country === 'IT' && shipTo.ship_to_state) {
        const normalized = shipTo.ship_to_state.trim().toUpperCase()
        if (!SAP_ITALIAN_PROVINCES.some((p) => p.code === normalized)) {
          missing.push('Provincia non valida')
        } else if (normalized !== shipTo.ship_to_state) {
          // Rinormalizza a monte del submit, per robustezza.
          shipTo.ship_to_state = normalized
        }
      }
      return missing
    },
    tryOrder () {
      // Validazione ship-to per ogni riga home-delivery prima del submit.
      // In step 3 l'utente ha compilato una ShipToFields per-riga associata
      // a items[i].shipTo; verifichiamo che tutti i required siano presenti.
      for (let i = 0; i < this.items.length; i++) {
        if (!this.lineHomeDelivery(i)) continue
        const missing = this.validateShipTo(i)
        if (missing.length) {
          this.emitter.emit('fireAlert', {
            msg: 'Riga #' + (i + 1) + ': dati spedizione mancanti o non validi (' + missing.join(', ') + ').',
            error: true
          })
          return
        }
      }
      this.loading = true
      const agreement = this.campData.agreement_no
      this.items.map(async (el, idx) => {
        const data = {
          agreement_no: agreement,
          pdv_id: this.pv,
          item_id: el.article.substitute,
          email: null,
          loyalty_card: null,
          customer_firstname: null,
          customer_lastname: null,
          customer_business_name: null,
          customer_client_code: null,
          customer_phone_number: null,
          quantity: el.qta
        }
        if (el.spediz.email) data.email = el.spediz.email
        if (this.shownFields.includes('loyalty_card')) data.loyalty_card = el.card
        if (this.shownFields.includes('customer_firstname')) data.customer_firstname = el.firstname
        if (this.shownFields.includes('customer_lastname')) data.customer_lastname = el.lastname
        if (this.shownFields.includes('customer_business_name')) data.customer_business_name = el.customer.business
        if (this.shownFields.includes('customer_client_code')) data.customer_client_code = el.customer.client
        if (this.shownFields.includes('customer_phone_number')) data.customer_phone_number = el.customer.phone
        if (this.lineHomeDelivery(idx)) Object.assign(data, el.shipTo)
        const result = await this.$store.dispatch('submitOrder', data)
        if (result) {
          this.orderSuccess.push(result)
        } else {
          this.orderSuccess.push({
            item: this.getDescription(el.article),
            failed: true
          })
        }
      })
      this.step = 4
      setTimeout(() => {
        this.loading = false
        if (this.checkSuccess(this.orderSuccess)) {
          this.refresh(3000)
        }
      }, 3000)
    },
    getCodeByDesc (desc) {
      const list = this.extraData.use_only_default_substitute_code ? this.alternates : this.prodAlt
      const target = list.filter((el) => {
        return el.item_code === desc.item_no
      })
      if (target && target[0]) return target[0]
    },
    getDescription (tgt, isAlternate) {
      const list = this.extraData.use_only_default_substitute_code ? this.alternates : this.prodAlt
      let alterTarget = null
      if (isAlternate) {
        alterTarget = list.filter((el) => {
          if (tgt && tgt.item_id) return el.substitute === tgt.item_id
        })
      }

      const list2 = this.extraData.use_only_default_substitute_code ? this.products : this.prodAlt
      let target = null
      if (alterTarget) {
        target = list2.filter((el) => {
          if (alterTarget[0] && alterTarget[0].item_code) return el.item_no === alterTarget[0].item_code
        })
      } else {
        target = list2.filter((el) => {
          if (tgt && tgt.item_code) return el.item_no === tgt.item_code
        })
      }
      if (target && target[0]) return target[0].item_description
      else return false
    },
    refreshInput (val, index) {
      if (!val) this.items[index].spediz.email = null
    },
    goTo (index) {
      if (index === 3) {
        let stop = false
        let msg = 'Impossibile elaborare l\'ordine: controlla bene i campi inseriti.'
        const lngth = this.items.length
        for (let i = 0; i < lngth; i++) {
          const el = this.items[i]
          const isCard = this.checkGroup(el.article)
          if (lngth !== 1 && !el.article) this.items.splice(i, 1)

          // ---CHECK REQUIRED FIELDS
          if (
            (lngth === 1 && !el.article) ||
            !el.qta ||
            (isCard && !el.spediz.email) ||
            (this.lineHomeDelivery(i) && !el.spediz.email) ||
            (this.lineInPrenotazione(i) && !el.customer.phone) ||
            (this.eanCheck === false) ||
            (this.requiredFields.includes('loyalty_card') && !el.card) ||
            (this.requiredFields.includes('customer_firstname') && !el.firstname) ||
            (this.requiredFields.includes('customer_lastname') && !el.lastname) ||
            (this.requiredFields.includes('customer_business_name') && !el.customer.business) ||
            (this.requiredFields.includes('customer_client_code') && !el.customer.client) ||
            (this.requiredFields.includes('customer_phone_number') && !el.customer.phone)
          ) stop = true

          // ---CHECK IF LOYALTY EAN13 IS VALID
          if (
            (this.eanCheck === false && el.card) ||
            (this.requiredFields.includes('loyalty_card') && !el.card)
          ) msg = 'Impossibile elaborare l\'ordine: uno o più numeri carta non risultano validi.'

          // ---CHECK IF DIGITAL CARD AND EMAIL FIELD IS EMPTY
          if (isCard && !el.spediz.email) msg = 'Impossibile elaborare l\'ordine: non hai inserito un indirizzo mail valido.'

          // ---CHECK phone obbligatorio per ordini "in prenotazione" (casi B e C)
          if (this.lineInPrenotazione(i) && !el.customer.phone) {
            msg = 'Impossibile elaborare l\'ordine: inserire un numero di telefono (Riga #' + (i + 1) + ').'
          }

          // ---CHECK email obbligatoria per consegna a domicilio (caso C: serve per il tracking)
          if (this.lineHomeDelivery(i) && !el.spediz.email) {
            msg = 'Impossibile elaborare l\'ordine: inserire un indirizzo email per il tracking della consegna (Riga #' + (i + 1) + ').'
          }
        }
        const error = !!stop
        if (stop) this.emitter.emit('fireAlert', { msg, error })
        else this.step = 3
      } else {
        this.step = index
      }
    },
    timeFormatter (time) {
      return moment(time).format('ll')
    },
    addEl (indexPlus) {
      this.items.push(
        {
          article: null,
          desc: null,
          qta: 1,
          card: null,
          firstname: null,
          lastname: null,
          spediz: {
            email: null
          },
          customer: {
            business: null,
            client: null,
            phone: null
          },
          selectedLine: null,
          shipTo: {
            ship_to_street: '',
            ship_to_zip_code: '',
            ship_to_city: '',
            ship_to_country: 'IT',
            ship_to_state: '',
            ship_to_address_name: '',
            ship_to_notes: '',
            floor_delivery_option: 'N'
          }
        }
      )
      this.overrider.push(
        {
          code: null,
          name: null
        }
      )
    },
    removeEl (index) {
      this.items.splice(index, 1)
      this.overrider.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="scss">
  @use "@/assets/scss/views/campaign.scss";
</style>
